import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Feature, FeatureFlagsAndLimitsState, Limit } from './state';
import { FEATURE_FLAGS_AND_LIMITS_FEATURE_KEY } from './reducers';

export const selectFeatureFlagsAndLimitsState = createFeatureSelector<FeatureFlagsAndLimitsState>(FEATURE_FLAGS_AND_LIMITS_FEATURE_KEY);

export const selectAllFeatures = createSelector(
  selectFeatureFlagsAndLimitsState,
  (state: FeatureFlagsAndLimitsState) => state?.features
);

export const selectAllLimits = createSelector(
  selectFeatureFlagsAndLimitsState,
  (state: FeatureFlagsAndLimitsState) => state.limits
);

export const selectLimitByIdentifier = (featureIdentifier: string) => createSelector(
  selectAllLimits,
  (limits: Limit[]) => limits.find(limit => limit.featureIdentifier === featureIdentifier)
);

export const selectFeatureByIdentifier = (featureIdentifier: string) => createSelector(
  selectAllFeatures,
  (features: Feature[]) => features?.find(feature => feature.featureIdentifier === featureIdentifier)
);

export const selectDowntime = createSelector(
  selectFeatureFlagsAndLimitsState,
  (state: FeatureFlagsAndLimitsState) => state.downtime
);